export function TeamBadge({ team, size = 28 }) {
  if (!team) return null;
  return (
    <span
      className="inline-flex items-center justify-center rounded-none font-data font-bold text-white shrink-0 border border-black/20"
      style={{ background: team.color, width: size, height: size, fontSize: size * 0.42 }}
    >
      {team.short}
    </span>
  );
}
